import { Controller } from '@hotwired/stimulus'

// Appended by a turbo stream to close the open Galette singleton dialog. Needed for
// turbo_method links inside a modal: their synthetic forms are created outside the
// dialog, so the dialog's own turbo:submit-end close never fires.
export default class extends Controller {
  connect() {
    const dialog = document.getElementById('modal-dialog-singleton')
    if (dialog?.open) {
      // The stream that closes us also replaced the panel, so the dialog's content has
      // no template to restore to — discard it, as the submit-end close path does.
      const controller = this.application.getControllerForElementAndIdentifier(dialog, 'ui--modal--dialog')
      if (controller) controller.shouldResetContent = true
      dialog.close()
    }
    this.element.remove()
  }
}
